<!--登录进度条组件-->
<template>
  <v-progress-linear :active="show" :indeterminate="true"></v-progress-linear>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },

  methods: {
    showp() {
      this.show = true
    },
    hidden() {
      this.show = false
    }
  }
}
</script>
